import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import UserCreator from './userCreator/UserCreator';
import UserList from './userList/UserList';

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    overflow-x: auto;
`;

const TableWrapper = styled.div`
    width: 100%;
    display: flex;
    overflow-x: auto;
`;

const Title = styled.div`
    margin-top: 40px;
    margin-bottom: 20px;
`;

class UserAdmin extends React.Component {
    render() {
        const { chosenCustomer, t, users, projects, getUsers, getProjects } = this.props;
        const { license } = chosenCustomer;
        return (
            <React.Fragment>
                <HeaderWrapper>
                    <span>{`${t('Your current license type')}:`} <b>{`${license.name}`}</b> </span>
                    <span>{`${t('User limit for that license')}:`} <b>{`${license.usersCountLimit}`}</b></span>
                </HeaderWrapper>
                {users.length > 0
                    ? <React.Fragment>
                        <Title>{t('Manage users in workspaces')}:</Title>
                        <TableWrapper>
                            <UserList
                                chosenCustomer={chosenCustomer}
                                getUsers={getUsers}
                                getProjects={getProjects}
                                users={users}
                                projects={projects}/> 
                        </TableWrapper>
                    </React.Fragment>
                    : null
                }
                <Title>{t('Create new user')}:</Title>
                <Wrapper>
                    <UserCreator                            
                        chosenCustomer={chosenCustomer}
                        getUsers={getUsers}
                        users={users}
                        limitExceeded={users.length >= license.usersCountLimit}
                    />
                </Wrapper>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(UserAdmin));



// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/userAdmin/UserAdmin.jsx